import { Box, Form, Spacer } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { ScrollView } from 'react-native'
import { useStores } from '../../../../../data/store'
import Header from './Header'
import { tidDetails } from './form'
import { styles } from './styles'
const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}
const TIDDetails = ({ entityId, tid, onClose, onStatusChange, type, from }: any) => {
  const { getTidDetails } = useStores((store) => ({
    getTidDetails: store.onboarding.getTidDetails,
  }))
  const [details, setDetails] = useState({
    mid: '',
    terminalId: '',
    terminalType: '',
    mobileNumber: '',
    nickName: '',
    issueRefund: '',
    acceptPayment: '',
    sodexoFlag: '',
    cashNCarry: '',
    vpa: '',
    status: '',
  })

  useEffect(() => {
    if (tid && entityId) {
      setDetails(getTidDetails(entityId, tid, type, from))
    }
  }, [entityId, getTidDetails, tid, type, from])

  const themes = styles()
  const [isEditMode, setEditMode] = useState(false)

  const onEditPress = () => {
    setEditMode((prev) => !prev)
  }

  const getStatusMeaning = (status: string) => {
    const statusMap = {
      N: 'Active',
      Y: 'InActive',
      D: 'Deleted',
    }
    return statusMap[status]
  }
  return (
    <ScrollView stickyHeaderIndices={[0]} style={themes.container}>
      <Header
        handleOnChange={onStatusChange}
        tid={tid}
        onClose={onClose}
        isEditMode={isEditMode}
        onEditPress={onEditPress}
        type={'TID'}
        status={details?.status?.toLowerCase()}
      />
      <Spacer size={20} hide={false} />
      <Box flexGrow={1} margin={40}>
        <Form
          formData={tidDetails(isEditMode)}
          actionButtons={() => <></>}
          initialValues={{
            mid: details?.mid ?? 'NA',
            tid: details?.terminalId ?? 'NA',
            terminalType: details?.terminalType ?? 'NA',
            mobile: details?.mobileNumber ?? 'NA',
            nickName: details?.nickName ?? 'NA',
            issueRefund: details?.issueRefund ?? 'NA',
            acceptPayment: details?.acceptPayment ?? 'NA',
            sodexoFlag: details?.sodexoFlag ?? 'NA',
            cashNCarry: details?.cashNCarry ?? 'NA',
            vpa: details?.vpa ?? '',
          }}
          container={FormBox}
        />
      </Box>
    </ScrollView>
  )
}
export { TIDDetails }
